import React, { useState, useCallback, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import favoriteChartBlack from "../../assets/images/restaurant-portal/favorite-chart-black.svg";
import favoriteChartOrange from "../../assets/images/restaurant-portal/favorite-chart-orange.svg";
import coinBlack from "../../assets/images/restaurant-portal/coin-black.svg";
import coinOrange from "../../assets/images/restaurant-portal/coin-orange.svg";
import profile from "../../assets/images/user-dashboard/profile.svg";
import profileOrange from "../../assets/images/user-dashboard/profile-orange.svg";
import NotificationDropdown from "../Common/NotificationDropdown";

//Import API
import endpoints from "../../api/endpoints";
import { get, patch } from "../../api/axios";

const AdminBottomNavigation = () => {
  const location = useLocation();
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const isActiveRoute = (path) => {
    return (
      location.pathname === path || location.pathname.startsWith(path + "/")
    );
  };

  // Fetch notifications
  const fetchNotifications = useCallback(async () => {
    try {
      const response = await get(`${endpoints.adminNotificationsUnread}`);
      if (response.data.success) {
        const notificationsData = response.data.data.data || [];
        const transformedNotifications = notificationsData.map((notif) => ({
          id: notif.id,
          title: notif.notification_type?.replace(/_/g, " ") || "Notification",
          message: notif.data?.message || notif.message || "",
          type: notif.notification_type || "system",
          read: notif.is_read || false,
          timeAgo: formatTimeAgo(notif.created_at),
          url: notif.data?.url || notif.data?.redirect_url || null,
        }));
        setNotifications(transformedNotifications);
      }
    } catch (err) {
      console.error("Failed to fetch notifications:", err);
    }
  }, []);

  // Fetch unread count separately
  const fetchUnreadCount = useCallback(async () => {
    try {
      const response = await get(endpoints.adminNotificationsUnreadCount);
      if (response.data.success) {
        const count = response.data.data?.unread_count || 0;
        setUnreadCount(Number(count));
      }
    } catch (err) {
      console.error("Failed to fetch unread count:", err);
    }
  }, []);

  // Format time ago
  const formatTimeAgo = (dateString) => {
    if (!dateString) return "Unknown";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // Fetch notifications on mount and set up polling
  useEffect(() => {
    fetchNotifications();
    fetchUnreadCount();

    // Poll for new notifications every 10 seconds
    const interval = setInterval(() => {
      fetchNotifications();
      fetchUnreadCount();
    }, 10000);

    return () => clearInterval(interval);
  }, [fetchNotifications, fetchUnreadCount]);

  const handleMarkAsRead = async (notificationId) => {
    try {
      if (notificationId === "all") {
        // Mark all as read using the read-all endpoint
        await patch(endpoints.adminNotificationsReadAll);
        setNotifications((prev) => prev.map((n) => ({ ...n, read: true })));
        fetchUnreadCount();
      } else {
        const endpoint = endpoints.adminNotificationMarkRead.replace(
          "{{NOTIFICATION_ID}}",
          notificationId,
        );
        await patch(endpoint);
        setNotifications((prev) =>
          prev.map((n) => (n.id === notificationId ? { ...n, read: true } : n)),
        );
        fetchUnreadCount();
      }
    } catch (err) {
      console.error("Failed to mark notification as read:", err);
    }
  };

  return (
    <div className="bottom-navigation">
      <nav className="bottom-nav">
        <Link
          to="/admin/dashboard"
          className={`bottom-nav-item ${isActiveRoute("/admin/dashboard") ? "active" : ""}`}
        >
          <img
            src={
              isActiveRoute("/admin/dashboard")
                ? favoriteChartOrange
                : favoriteChartBlack
            }
            alt="Home"
            className="bottom-nav-icon"
          />
          <span>Home</span>
        </Link>

        <Link
          to="/admin/settlements"
          className={`bottom-nav-item ${isActiveRoute("/admin/settlements") ? "active" : ""}`}
        >
          <img
            src={isActiveRoute("/admin/settlements") ? coinOrange : coinBlack}
            alt="Settlements"
            className="bottom-nav-icon"
          />
          <span>Settlements</span>
        </Link>
        <Link
          to="/admin/profile"
          className={`bottom-nav-item ${isActiveRoute("/admin/profile") ? "active" : ""}`}
        >
          <img
            src={isActiveRoute("/admin/profile") ? profileOrange : profile}
            alt="Profile"
            className="bottom-nav-icon"
          />
          <span>Profile</span>
        </Link>
        <div className="bottom-nav-item notification-tab">
          <NotificationDropdown
            notifications={notifications}
            unreadCount={unreadCount}
            viewAllPath="/admin/notifications"
            onMarkAsRead={handleMarkAsRead}
            direction="up"
            onOpen={fetchNotifications}
          />
        </div>
      </nav>
    </div>
  );
};

export default AdminBottomNavigation;
